export enum TaxInvoiceCompanyTypeEnum {
    JuristicPerson = 1,
    Individual = 2,
}
